// Google Analytics 4 implementation
// Only loads in production environment

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

export const initGA4 = (): void => {
  // Only initialize in production
  if (process.env.NODE_ENV !== 'production') {
    console.log('GA4: Disabled in development mode');
    return;
  }

  const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;

  if (!measurementId) {
    console.error('GA4: Measurement ID not found in environment variables');
    return;
  }

  // Load gtag.js script dynamically
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer!.push(arguments);
  };

  // Configure GA4
  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    anonymize_ip: true,
    send_page_view: true,
  });

  console.log(`GA4: Initialized with ID: ${measurementId}`);
};

interface EventParams {
  [key: string]: any;
}

export const trackEvent = (eventName: string, eventParams?: EventParams): void => {
  // Only track in production when gtag is available
  if (process.env.NODE_ENV === 'production' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};
